module.exports = __webpack_public_path__ + "static/media/history_28.68cb9ae7.jpg";